import React from 'react';
import { Loader2 } from 'lucide-react';
import { usePublicTenant } from '../../hooks/usePublicTenant';
import { LandingPage } from '../../pages/LandingPage';
import { MalayLandingPage } from '../../pages/landing/MalayLandingPage';
import { setPublicTenantIntent, clearPublicTenantIntent } from '../../utils/publicTenantHandoff';

export const PublicLandingResolver: React.FC = () => {
  const { isMalay, branding, loading } = usePublicTenant();

  React.useEffect(() => {
    if (!loading) {
      if (isMalay) {
        setPublicTenantIntent({
          isMalay: true,
          language: 'ms',
          source: 'public-route',
          landingPath: window.location.pathname,
        });
      } else {
        clearPublicTenantIntent();
      }
    }
  }, [isMalay, loading]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white dark:bg-gray-950" aria-busy="true">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-orange-500" aria-hidden />
          <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Loading portal...</span>
        </div>
      </div>
    );
  }

  if (isMalay) {
    return <MalayLandingPage branding={branding} />;
  }

  return <LandingPage />;
};
